import { AnimatePresence, motion } from 'framer-motion';
import { IoMdClose } from 'react-icons/io';
import DeleteIcon from '../../../styles/icons/delete-icon.svg';

import FilterLayout from './filter.layout.component';
import * as styled from './styled';
import { useNewsFilter } from './use.news.filter';

interface Props {
  onClose: () => void;
  selectedTypes: string[];
  onApply: (types: string[]) => void;
  newsTypes?: string[];
}

const NewsFiltersComponent = ({ onClose, selectedTypes, onApply, newsTypes }: Props) => {
  const { state, controls, data } = useNewsFilter(onClose, selectedTypes, onApply, newsTypes);

  return (
    <FilterLayout
      title='Тип новин'
      selectedCount={data.chips.length}
      onApply={controls.apply}
      onReset={controls.reset}
      onClose={onClose}
    >
      <AnimatePresence>
        {data.chips.length > 0 && (
          <>
            <styled.SelectedText>
              <span>Обрано</span>
              <img src={DeleteIcon} alt='clear' onClick={controls.reset} />
            </styled.SelectedText>
            <motion.div
              key='selected-block'
              layout
              initial={{ opacity: 0, height: 0 }}
              animate={{ opacity: 1, height: 'auto' }}
              exit={{ opacity: 0, height: 0 }}
              transition={{ duration: 0.25 }}
              style={{ overflow: 'hidden' }}
            >
              <styled.SelectedBar layout>
                <AnimatePresence mode='popLayout'>
                  {data.chips.map(chip => (
                    <motion.div
                      key={chip.id}
                      layout
                      initial={{ opacity: 0, y: -8, scale: 0.95 }}
                      animate={{ opacity: 1, y: 0, scale: 1 }}
                      exit={{ opacity: 0, y: -8, scale: 0.9 }}
                      transition={{ duration: 0.18 }}
                    >
                      <styled.Chip layout>
                        <span>{chip.label}</span>
                        <IoMdClose onClick={chip.onRemove} color='#01924f' />
                      </styled.Chip>
                    </motion.div>
                  ))}
                </AnimatePresence>
              </styled.SelectedBar>
            </motion.div>
          </>
        )}
      </AnimatePresence>

      <styled.OptionsGrid>
        {state.newsTypes?.map(type => (
          <styled.OptionLabel key={type}>
            <styled.Checkbox
              checked={state.pendingTypes.includes(type)}
              onChange={() => controls.toggleType(type)}
            />
            <span>{type}</span>
          </styled.OptionLabel>
        ))}
      </styled.OptionsGrid>
    </FilterLayout>
  );
};

export default NewsFiltersComponent;
